import React, { useState } from 'react';

import { Popover } from 'antd';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';

import EventDrawer from '@components/EventDrawer/EventDrawer';
import NwIcon from '@components/Gui/NwIcon';

import AddEventDropdownContent from './AddEventDropdownContent';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div``;

const AddEventDropdown = ({ date, modelID, onCreateEvent }) => {
    //onAddEvent

    //const [isOpenDrawer, setOpenDrawer] = useState(false);
    //const [eventType, setEventType] = useState();
    const [open, setOpen] = useState(false);

    // const afterRemove = () => {
    //     onAddEvent();
    //     setOpenDrawer(false);
    //     setEventType();
    // };

    const handleCreateEvent = (type) => {
        // setEventType(type);
        // setOpen(false);
        // setOpenDrawer(true);
        onCreateEvent(type, date);
    };

    // const handleCloseDrawer = () => {
    //     setOpenDrawer(false);
    // };

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    return (
        <Wrapper>
            <Popover
                zIndex={9999}
                overlayClassName="folder-popover"
                placement="bottom"
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                content={<AddEventDropdownContent onCreateEvent={handleCreateEvent} modelID={modelID} />}
            >
                {open ? (
                    <NwIcon icon={byPrefixAndName.fasl['times']} pointer />
                ) : (
                    <NwIcon icon={byPrefixAndName.fasl['circle-plus']} pointer />
                )}
            </Popover>
            {/* {isOpenDrawer ? (
                <EventDrawer
                    afterRemove={afterRemove}
                    afterUpdate={onAddEvent}
                    allDay={true}
                    dateSelected={getMoment(date)}
                    eventInfo={eventType.eventInfo}
                    eventType={eventType.type}
                    modelId={modelID}
                    onClose={handleCloseDrawer}
                    show={true}
                    viewMode="create"
                />
            ) : null} */}
        </Wrapper>
    );
};

export default AddEventDropdown;
